module.exports = __webpack_public_path__ + "static/img/banner.33f2fc7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/universityHall/images/banner.jpg
// module id = jKH9
// module chunks = 0